import {
  Box,
  Stack,
  Typography,
  type SxProps,
  type Theme,
} from '@mui/material';
import { ReactNode } from 'react';

export interface SectionHeaderProps {
  /** The section title displayed on the left */
  title: ReactNode;
  /** Optional action element rendered on the right (e.g. icon buttons) */
  actions?: ReactNode;
  /** Spacing below the header (theme spacing units). Default 1.5. */
  mb?: number;
  sx?: SxProps<Theme>;
}

export function SectionHeader({
  title,
  actions,
  mb = 1.5,
  sx,
}: SectionHeaderProps) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb, minHeight: 28, ...sx }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: 'text.secondary',
          fontWeight: 600,
          letterSpacing: '0.01em',
          lineHeight: 1,
        }}
      >
        {title}
      </Typography>
      {actions && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>{actions}</Box>
      )}
    </Stack>
  );
}
